<h2 mat-dialog-title class="cs-title">
	<mat-icon>approval</mat-icon>
	Relevés d'heures à viser
</h2>

<mat-dialog-content class="cs-content">
	<div class="cs-rows">
		@for (row of data.rows; track row.doc.id) {
			<div class="cs-row" [class.selected]="selected === row" (click)="onSelect(row)">
				<mat-icon class="cs-wait">hourglass_bottom</mat-icon>
				<div class="cs-main">
					<div class="cs-name">{{ row.name }}</div>
					<div class="cs-sub">{{ weekLabel(row) }} · {{ h(row.total_min) }} · {{ signedLabel(row) }}</div>
				</div>
				<button mat-icon-button matTooltip="Voir le relevé signé par le salarié (PDF)" aria-label="Voir le relevé signé par le salarié (PDF)"
					(click)="onOpenDoc(row); $event.stopPropagation()">
					<mat-icon>picture_as_pdf</mat-icon>
				</button>
			</div>
		} @empty {
			<div class="cs-empty">Aucun relevé en attente de visa.</div>
		}
	</div>

	@if (selected) {
		<div class="cs-sign">
			<div class="cs-pad-head">
				<span class="cs-pad-label">
					Visa du responsable — {{ selected.name }}, {{ weekLabel(selected) }}.
					Le serveur revérifie le décompte avant d'archiver.
				</span>
				<button mat-stroked-button (click)="onClear()">
					<mat-icon>clear</mat-icon>&nbsp;Effacer
				</button>
			</div>
			<app-signature-pad class="cs-pad"></app-signature-pad>
			<div class="cs-actions">
				<button mat-flat-button color="primary" id="countersignbutton"
					[disabled]="!signReady()" (click)="onCountersign()">
					<mat-icon>approval</mat-icon>&nbsp;Viser ce relevé
				</button>
			</div>
		</div>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-stroked-button (click)="onClose()">Fermer</button>
</mat-dialog-actions>
